"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMeasurementProvider = void 0;
var isMeasurementProvider = function (c) { return typeof c.getMeasurements === 'function'; };
exports.isMeasurementProvider = isMeasurementProvider;
//# sourceMappingURL=measurement.provider.js.map